








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander } from '@/components/table'
import { QueryKuaidi100SubscribePendingList, RetryKuaidi100Subscribe } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'

interface QueryParams {
  pageNum: number
  pageSize: number
  subscribeStatus: string | number
  orderCode: string
  expressCode: string
}

interface PendingRow {
  id: number
  subscribeStatus?: number
  [key: string]: unknown
}

@Component({ components: { VQuery, VTable } })
export default class Kuaidi100SubscribePendingList extends Vue {
  private queryParam: QueryParams = {
    pageNum: 1,
    pageSize: 10,
    subscribeStatus: '',
    orderCode: '',
    expressCode: '',
  }
  private tableTotal = 0
  private tableData: PendingRow[] = []

  private queryModels: Array<QueryModel> = [
    { title: '状态', param: 'subscribeStatus', type: 'select', selectData: [
      { label: '全部', value: '' },
      { label: '待处理', value: 0 },
      { label: '已成功', value: 1 },
    ]},
    { title: '订单号', param: 'orderCode' },
    { title: '运单号', param: 'expressCode' },
  ]

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '订单号', param: 'orderCode', width: 180, overflow: true },
    { title: '运单号', param: 'expressCode', width: 160, overflow: true },
    { title: '快递公司', param: 'companyName', width: 120, overflow: true },
    { title: '编码', param: 'companyCode', width: 90 },
    { title: '状态', param: 'subscribeStatus', width: 88, formatter: (v: number) => v === 1 ? '已成功' : '待处理' },
    { title: '重试次数', param: 'retryCount', width: 90 },
    { title: '失败原因', param: 'lastErrorMsg', overflow: true, width: 260 },
    { title: '创建时间', param: 'createTime', width: 160, formatter: DateFormat },
    {
      title: '操作',
      width: 120,
      fixed: 'right',
      operation: [
        {
          title: '重试订阅',
          click: this.onRetry,
          show: (row: PendingRow) => row.subscribeStatus === 0,
        },
      ],
    },
  ]

  mounted(): void {
    this.loadData()
  }

  private search() {
    this.queryParam.pageNum = 1
    this.loadData()
  }

  private sizeChange(size: number) {
    this.queryParam.pageSize = size
    this.loadData()
  }

  private pageChange(page: number) {
    this.queryParam.pageNum = page
    this.loadData()
  }

  private async loadData() {
    let subscribeStatus: number | null = null
    const st = this.queryParam.subscribeStatus
    if (st !== '' && st !== undefined && st !== null) {
      subscribeStatus = Number(st)
    }
    const res = await QueryKuaidi100SubscribePendingList({
      pageNum: this.queryParam.pageNum,
      pageSize: this.queryParam.pageSize,
      subscribeStatus,
      orderCode: this.queryParam.orderCode || undefined,
      expressCode: this.queryParam.expressCode || undefined,
    })
    if (!res) {
      return
    }
    this.tableData = res.list || []
    this.tableTotal = res.total != null ? res.total : 0
  }

  private onRetry(row: PendingRow): void {
    MessageBox.confirm('确定向快递100重新发起订阅？', '提示', { type: 'warning' })
      .then(async () => {
        const ok = await RetryKuaidi100Subscribe({ id: row.id })
        if (ok) {
          Message.success('订阅成功')
          this.loadData()
        }
      })
      .catch(() => { /* 用户取消 */ })
  }
}
